<template>
  <div id="reservations" >
    <!-- <div class="reservation-background" v-if="lastName != null && !resDeleted">  -->
    <div class="reservation-background" v-if="lastName != null"> 
      <reservation-booked
        :bookingCompletedMessage="'Your Booking Details:'"
      />

      <div id="reservation-modify-actions" v-if="!resDeleted">
        <!-- <el-button 
          @click="modifyRes"
          type="primary">
          Decrease Party Size
        </el-button> -->
        <el-button 
          @click="modifyRes"
          type="primary">
          Modify Booking
        </el-button>
        <el-button 
          @click="deleteRes"
          type="primary">
          Cancel Booking
        </el-button>
      </div>
    </div>
    <div id="reservation-deleted" class="reservation-background" v-if="resDeleted">
      Your reservation has been cancelled or could not be found!
    </div>
  </div>
</template>

<script>
import reservationBooked from '@comp/reservationBooked'
import { mapState } from 'vuex'

export default {
  components: {
    reservationBooked
  },
  props: [ "res_token" ],
  computed: {
    ...mapState( {
      lastName: state => state.userInfo.lastName,
      resDeleted: state => state.userInfo.resDeleted,
      location: state => state.availability.location,
      date: state => state.availability.date,
    } )
  },
  methods: {
    deleteRes() {
      this.$confirm('This will cancel your priority booking reservation. Continue?', null, {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          this.$store.dispatch( "userInfo/deleteReservation" )     
        }).catch(() => {
          
        })
    },
    async modifyRes() {
      await this.$store.dispatch( 'availability/getUpdatedTimes', { location: this.location, date: this.date } )
      this.$store.dispatch( "userInfo/modifyReservation" )
    }
  },
  mounted() {
  }
}
</script>

<style>

#reservations {
  box-sizing:border-box;
  margin-top: 20px;
  padding: 10px;
}

.reservation-background {
  box-sizing:border-box;
  width: 100%;
  background-color: white;
  padding: 10px;
  border-radius: 5px;
  text-align: center;
}

#reservation-modify-actions {

}

#reservation-deleted {
  font-weight: bold;
  padding: 20px;
}

</style>